module.exports = __webpack_public_path__ + "static/img/about-us.0d1ca0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-us.png
// module id = xCzM
// module chunks = 10